import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { ButtonGroup, SHAPE, SIZE } from "baseui/button-group";
import { FormControl } from "baseui/form-control";
import { addMinutes, endOfDay, startOfDay } from "date-fns";
import { TValueOption, ValueCellSelector } from "../components/ValueCellSelector";
import { IAddEventState } from "./AddEntryDialog";
import { useIntl, FormattedMessage } from 'react-intl';
import { default as EditTimeRangeForm } from "../components/EditTimeRangeForm";


const AddEntryForm = (props: {
    state: IAddEventState,
    setState: any,
    dataType: string,
    showDays: boolean,
    valueOptions: TValueOption[] | undefined
}) => {
    const intl = useIntl();

    function toggleDay(index: number) {
        const tmp = [...props.state.days];
        tmp[index] = !tmp[index];
        props.setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            days: tmp
        }))
    }

    function handleTimeFromChanged(time: Date | null) {
        if (!time)
            return;

        if (time >= props.state.timeTo)
            time = addMinutes(props.state.timeTo, -15);

        props.setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            timeFrom: time as Date
        }))
    }
    function handleTimeToChanged(time: Date | null) {
        if (!time)
            return;
        if (time <= props.state.timeFrom)
            time = addMinutes(props.state.timeFrom, 15);

        props.setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            timeTo: time as Date
        }))
    }

    function onValueChanged(newValue: any) {
        props.setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            value: newValue
        }))
    }

    return (
        <Block display='flex' flexDirection='column' >
            <EditTimeRangeForm timeFrom={props.state.timeFrom} timeTo={props.state.timeTo} onTimeFromChange={handleTimeFromChanged} onTimeToChange={handleTimeToChanged}></EditTimeRangeForm>

            <FormControl
                label={() => intl.formatMessage({ id: "valueInput", defaultMessage: "Value" })}
                caption={() => intl.formatMessage({ id: "valueInputDescription", defaultMessage: "Select a value" })}
            >
                <ValueCellSelector valueOptions={props.valueOptions}  dataType={props.dataType} value={props.state.value} onValueChanged={onValueChanged}></ValueCellSelector>
            </FormControl>
            {props.showDays &&
                <FormControl
                    label={() => intl.formatMessage({ id: "daysSelect", defaultMessage: "Days" })}
                    caption={() => intl.formatMessage({ id: "daysSelectDescription", defaultMessage: "Select the days" })}
                >
                    <ButtonGroup
                        size={SIZE.default}
                        shape={SHAPE.default}
                        mode="checkbox"
                    >
                        <Button isSelected={props.state.days[0]} onClick={() => toggleDay(0)}><FormattedMessage id="weekday.short.monday" defaultMessage="Mon" /></Button>
                        <Button isSelected={props.state.days[1]} onClick={() => toggleDay(1)}><FormattedMessage id="weekday.short.tuesday" defaultMessage="Tue" /></Button>
                        <Button isSelected={props.state.days[2]} onClick={() => toggleDay(2)}><FormattedMessage id="weekday.short.wednesday" defaultMessage="Wed" /></Button>
                        <Button isSelected={props.state.days[3]} onClick={() => toggleDay(3)}><FormattedMessage id="weekday.short.thursday" defaultMessage="Thu" /></Button>
                        <Button isSelected={props.state.days[4]} onClick={() => toggleDay(4)}><FormattedMessage id="weekday.short.friday" defaultMessage="Fri" /></Button>
                        <Button isSelected={props.state.days[5]} onClick={() => toggleDay(5)}><FormattedMessage id="weekday.short.saturday" defaultMessage="Sat" /></Button>
                        <Button isSelected={props.state.days[6]} onClick={() => toggleDay(6)}><FormattedMessage id="weekday.short.sunday" defaultMessage="Sun" /></Button>
                    </ButtonGroup>
                </FormControl>
            }
        </Block>
    );
};


export default AddEntryForm;